export const SEARCH_AGENT_START = 'SEARCH_AGENT_START';
export const SEARCH_AGENT_SUCCESS = 'SEARCH_AGENT_SUCCESS';
export const SEARCH_AGENT_ERROR = 'SEARCH_AGENT_ERROR';
